import { createReducer } from '@reduxjs/toolkit';
import {
    END_REQUEST_NOW_PLAYING, REQUEST_NOW_PLAYING, UPDATE_NOW_PLAYING,
} from '../actions/NowPlayingActions';
import { PLAY_MEDIA_FROM_SOURCE_WITH_META } from '../actions/MediaPlayerActions';

const initialState = {
    isFetching: false,
    lastUpdated: null,
    lastFetched: null,
    music: {},
    musicLive: {},
};

const nowPlaying = createReducer(initialState, (builder) => {
    builder
        .addCase(END_REQUEST_NOW_PLAYING, (state) => {
            state.isFetching = false;
            state.lastFetched = Date.now();
        })
        .addCase(REQUEST_NOW_PLAYING, (state) => {
            state.isFetching = true;
        })
        .addCase(UPDATE_NOW_PLAYING, (state, action) => {
            state.musicLive = action.music;
            state.lastUpdated = action.receivedAt;
        })
        .addCase(PLAY_MEDIA_FROM_SOURCE_WITH_META, (state, action) => {
            state.music = action.payload.meta;
        });
});

export default nowPlaying;
